import React from "react";

export const ArrowDownIcon = (props) => {
  return (
    <>
      <svg
        onClick={props?.onClick}
        className={props.className}
        width="12"
        height="9"
        viewBox="0 0 13 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 5.76438L11.3863 0.590803C11.6892 0.270113 12.1994 0.270113 12.5023 0.590803C12.7816 0.886603 12.7816 1.34902 12.5023 1.64482L6.5 8L0.49774 1.64482C0.218366 1.34902 0.218366 0.886604 0.49774 0.590804C0.800621 0.270114 1.31085 0.270114 1.61373 0.590804L6.5 5.76438Z"
          fill="#231F20"
          stroke="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: "1",
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: "1",
            strokeWidth: "0.5",
          }}
        />
      </svg>
    </>
  );
};
